import { configureStore } from '@reduxjs/toolkit'

// Import all slices
import authReducer from './slices/authSlice'
import patientsReducer from './slices/patientsSlice'
import usersReducer from './slices/usersSlice'
import prescriptionsReducer from './slices/prescriptionsSlice'
import ordersReducer from './slices/ordersSlice'
import medicationsReducer from './slices/medicationsSlice'
import formularyReducer from './slices/formularySlice'
import clinicsReducer from './slices/clinicsSlice'
import pharmaciesReducer from './slices/pharmaciesSlice'
import invoicesReducer from './slices/invoicesSlice'
import adminReducer from './slices/adminSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    patients: patientsReducer,
    users: usersReducer,
    prescriptions: prescriptionsReducer,
    orders: ordersReducer,
    medications: medicationsReducer,
    formulary: formularyReducer,
    clinics: clinicsReducer,
    pharmacies: pharmaciesReducer,
    invoices: invoicesReducer,
    admin: adminReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch